export default __webpack_public_path__ + "static/media/_url_link.55a8eb34.svg";